import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import AppbarLogo from 'assets/primary_logo.png'
import { Box } from '@mui/material'

const LogoWithConference = ({ confName }) => {
  const classes = useStyles()
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
      <img className={classes.logo} alt="Remy Sharp" src={AppbarLogo} />
      <Typography className={classes.confName}>{confName}</Typography>
    </Box>
  )
}

const useStyles = makeStyles({
  logo: {
    height: 55,
    width: 125
  },
  confName: {
    fontSize: '22px',
    fontWeight: 600,
    marginLeft: '260px'
  }
})
export default LogoWithConference
